"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.malay = void 0;
var types_1 = require("../types");
exports.malay = {
    code: types_1.LocaleCode.Malay,
    facebook: 'ms_MY',
    label: 'Bahasa Melayu',
    loadingText: 'Memuatkan...',
    translations: {
        ar: 'Bahasa Arab',
        de: 'Bahasa Jerman',
        en: 'Bahasa Inggeris',
        es: 'Bahasa Sepanyol',
        fr: 'Bahasa Perancis',
        id: 'Bahasa Indonesia',
        it: 'Bahasa Itali',
        ja: 'Bahasa Jepun',
        ko: 'Bahasa Korea',
        lo: 'Bahasa Lao',
        ms: 'Bahasa Melayu',
        pt: 'Bahasa Portugal',
        ru: 'Bahasa Rusia',
        th: 'Bahasa Thai',
        tl: 'Bahasa Filipina',
        tr: 'Bahasa Turki',
        vi: 'Bahasa Vietnam',
        'zh-CN': '‪Bahasa Cina (dimudah.)',
        'zh-TW': '‪Bahasa Cina (trad.)'
    }
};
